import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import type { RouterClient } from "@orpc/server";
import type { ApiRouter } from "backend/src/api";

const baseUrl: string = import.meta.env.VITE_API_URL ?? "";

if (!baseUrl) {
  throw new Error("VITE_API_URL is not set");
}

// Token provider function - set by AuthenticatedUserProvider
let getTokenFn: (() => Promise<string>) | null = null;

export const setAuthTokenProvider = (fn: () => Promise<string>) => {
  getTokenFn = fn;
};

const link = new RPCLink({
  url: `${baseUrl}/api/v1`,
  headers: async () => {
    if (!getTokenFn) {
      throw new Error("Auth token provider not set. Ensure AuthenticatedUserProvider is mounted.");
    }
    const token = await getTokenFn();
    return { Authorization: `Bearer ${token}` };
  },
});

const publicLink = new RPCLink({
  url: `${baseUrl}/api/v1`,
});

export const apiClient: RouterClient<ApiRouter> = createORPCClient(link);
export const publicApiClient: RouterClient<ApiRouter> = createORPCClient(publicLink);
